export default "__VITE_ASSET__D5ePA6hF__$_?no-inline__"